module.exports = __webpack_public_path__ + "abaa85e5a755ad45845f2d89e780eaef.png";